import { useMemo } from 'react';
import { createRouteConfig } from '@/routers/RouteConfig';
import { useBasePath } from './useBasePath';

/**
 * Custom hook to access route configuration with dynamic basePath from context
 * @returns RouteConfig object with routes and utility functions
 */
export const useRouteConfig = () => {
  const { basePath } = useBasePath();

  return useMemo(() => {
    return createRouteConfig(basePath);
  }, [basePath]);
};

/**
 * Hook specifically for getting URL from page name with dynamic basePath from context
 * @returns Function to get URL from page name
 */
export const useGetUrlFromPageName = () => {
  const { getUrlFromPageName } = useRouteConfig();
  return getUrlFromPageName;
};
